import { FC } from 'react'
import './Error.scss'

const Error: FC = () => {
    return (
        <>
        <div className="error-page">
            <p>404 <span></span> Page Not Found</p>
        </div>
        </>
    )
}

export default Error
